export const version = '2.45.1'
